module.exports = __webpack_public_path__ + "img/trans-location-icon.470b1946.svg";